var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card-content",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { style: { padding: "0px 15px" } },
            [
              _c("w-input", {
                attrs: {
                  fancy: "",
                  value: _vm.message,
                  label: _vm.$ct("labels.description"),
                },
                on: {
                  input: function ($event) {
                    return _vm.onMessage($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("app-aws-files-edit", {
        attrs: {
          files: _vm.value.AWSDocuments,
          "to-add-files": _vm.value.UnprocessedFiles,
          "to-remove-files": _vm.value.toDeleteFiles,
          multiple: true,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }